// The selected account carries the acquisition cost when import VAT is not
// deductible. Do not invent an expense account for incomplete legacy records.
const customsDeclarationPostings = (entry: any) => {
  const code = String(entry.customsVatCode || '81');
  const outgoingVat = code === '85' ? 0 : num(entry.outgoingVat ?? entry.outputVat ?? entry.vatAmount);
  const deductibleVat = code === '81' || code === '83' ? num(entry.deductibleVat ?? entry.inputVat ?? entry.vatAmount) : 0;
  if (outgoingVat < 0 || deductibleVat < 0 || deductibleVat > outgoingVat) throw new Error('Import VAT amounts must be non-negative and deduction cannot exceed output VAT.');
  const nonDeductible = Math.round((outgoingVat - deductibleVat) * 100) / 100;
  const account = String(entry.nonDeductibleVatAccountCode || '').trim();
  if (nonDeductible > 0 && !/^(1[0-4]\d{2,3}|[4-7]\d{3,4})$/.test(account)) {
    throw new Error('Non-deductible import VAT requires an explicit expense or acquisition-cost account.');
  }
  return [
    posting('2700', 'Import VAT', entry.description || 'Customs declaration', -outgoingVat),
    deductibleVat ? posting('2710', 'Deductible import VAT', entry.description || 'Customs declaration', deductibleVat) : null,
    nonDeductible ? posting(account, entry.nonDeductibleVatAccountName || account, entry.description || 'Non-deductible import VAT', nonDeductible) : null,
  ].filter(Boolean);
};
